import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AiRemoveBgPanelProps} from '@Panels/ai-remove-bg-panel/ai-remove-bg-panel';

export const openAiRemoveBgModal = (props?: AiRemoveBgPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_REMOVE_BG,
      panelProps: {...props},
    })
  );
};
